export default __webpack_public_path__ + "static/gabrielcheang2-9d836207dbfde7be3bb6bb4a691260ce.jpg";